import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";

let brandingCache = null;

export function useBranding() {
  const [branding, setBranding] = useState(brandingCache || { loaded: false });
  useEffect(() => {
    if (brandingCache) return;
    api.get("/branding")
      .then((r) => { brandingCache = { ...(r.data || {}), loaded: true }; setBranding(brandingCache); })
      .catch(() => setBranding({ loaded: true }));
  }, []);
  return branding;
}

export function refreshBranding(next) {
  brandingCache = next;
}

export function Logo({ compact = false }) {
  const branding = useBranding();
  if (branding.logo_url) {
    return (
      <img src={fileUrl(branding.logo_url)} alt="Lomond Plant" className="h-9 w-auto object-contain" data-testid="brand-logo-image" />
    );
  }
  return (
    <span className="inline-flex items-center gap-2" data-testid="brand-logo-text">
      <span className="bg-lomond text-black font-heading font-black uppercase tracking-wider px-2.5 py-1 rounded-sm shadow-md leading-none">
        LOMOND
      </span>
      {!compact && (
        <span className="font-heading font-bold uppercase tracking-widest text-charcoal text-sm leading-tight">
          Operator<br className="hidden sm:block" /> Academy
        </span>
      )}
    </span>
  );
}

export function DemoBadge() {
  return (
    <span data-testid="demo-mode-badge" className="text-[10px] font-mono font-bold uppercase tracking-widest bg-amber-100 text-amber-800 border border-amber-300 rounded-sm px-1.5 py-0.5">
      Demo
    </span>
  );
}
